import { makeVar } from '@apollo/client';

export const authErrorMessageVar = makeVar<string | undefined>(undefined);
